export const GalexyPlanningData = {
  tabs: [
    {
      label: 'All Galexy Planning Data',
      id: 1,
    },
  ],
};